/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxBondApiGetBondRedemptionListType = typeof UtxBondApiGetBondRedemptionListType[keyof typeof UtxBondApiGetBondRedemptionListType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxBondApiGetBondRedemptionListType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  NONE: 'NONE',
} as const;
